exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".iopen-wf-batch{\r\n  display: inline-block;\r\n  margin-left: 10px;\r\n  background: #00BD89;\r\n  color: #fff;\r\n  padding: 0 5px;\r\n}\r\n.iopen-validate-element .el-select{\r\n  width: 33%;\r\n}\r\n.iconfont.small{\r\n  font-size: 12px;\r\n}\r\n.wf-source-type{\r\n  display: inline-block;\r\n  padding: 0 5px;\r\n  border-radius: 4px;\r\n}", ""]);

// exports
